import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '../../environments/environment';

import 'rxjs/add/operator/toPromise';

import { Payment } from '../models/payment';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class PaymentService {

  constructor(private http: HttpClient, private translateService: TranslateService) { }

  getPayment(invoiceToken: string, chamberID: string, saveCard: boolean = false): Promise<any> {
    const lang = this.translateService.currentLang;
    return this.http.get<Payment>(environment.apiURL + 'Payment/' + invoiceToken + '?chamberid=' + chamberID + '&savecardinfo=' + saveCard + '&lang=' + lang)
      .toPromise()
      .then(response => response)
      .catch(error => Promise.reject(this.translateService.instant('APIErrors.ErrorWithDetails', {error: error}))
    );
  }

  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error); // for demo purposes only
    return Promise.reject(error.message || error);
  }
}



// WEBPACK FOOTER //
// /home/ubuntu/MembriPay/src/app/services/payment.service.ts